import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4063b330"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "clipboard"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "copied to clipboard", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_6 = { class: "card-body mb-4 pt-9 pb-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-xmark" }, null, -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col flex-grow-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "pb-2 pt-3" }, "GoatNote", -1))
const _hoisted_12 = { class: "text-nowrap" }
const _hoisted_13 = {
  class: "col d-flex",
  style: {"align-items":"center"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "pb-2 pt-3" }
const _hoisted_18 = ["id"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen inside-input" }, null, -1))
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "pb-2 pt-3" }
const _hoisted_22 = ["onChange", "id"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen inside-input" }, null, -1))
const _hoisted_24 = ["id"]
const _hoisted_25 = ["selected", "value"]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "pb-2 pt-3" }
const _hoisted_30 = ["onChange", "id"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen inside-input" }, null, -1))
const _hoisted_32 = { class: "col-1 m-2" }
const _hoisted_33 = { class: "list-unstyled" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "col-1 m-2" }
const _hoisted_36 = { class: "list-unstyled" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "col-1 m-2" }
const _hoisted_39 = { class: "list-unstyled" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "col-1 m-2" }
const _hoisted_42 = { class: "list-unstyled" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "col-1 m-2" }
const _hoisted_45 = { class: "list-unstyled" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "col-1 m-2" }
const _hoisted_48 = { class: "list-unstyled" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "col-1 m-2" }
const _hoisted_51 = { class: "list-unstyled" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "col-1 m-2" }
const _hoisted_54 = { class: "list-unstyled" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_57 = { key: 3 }
const _hoisted_58 = { class: "pb-2 pt-3" }
const _hoisted_59 = ["onChange", "id"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen inside-input" }, null, -1))
const _hoisted_61 = { class: "list-group" }
const _hoisted_62 = ["checked", "id", "value", "data-group", "onClick"]
const _hoisted_63 = { key: 4 }
const _hoisted_64 = { class: "pb-2 pt-3" }
const _hoisted_65 = ["onChange", "id"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen inside-input" }, null, -1))
const _hoisted_67 = { class: "list-group" }
const _hoisted_68 = ["checked", "id", "value", "onChange", "data-group"]
const _hoisted_69 = ["id"]
const _hoisted_70 = { class: "row mt-auto" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, null, -1))
const _hoisted_72 = { class: "col-4 d-flex align-items-center justify-content-end mb-5" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_74 = {
  class: "col-10",
  style: {"margin-top":"30px"}
}
const _hoisted_75 = { class: "row" }
const _hoisted_76 = ["id"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_78 = { class: "" }
const _hoisted_79 = { class: "pb-2 pt-3" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode("Note Preview")
const _hoisted_81 = { class: "bg-blue" }
const _hoisted_82 = { class: "p-5" }
const _hoisted_83 = {
  key: 0,
  class: "row"
}
const _hoisted_84 = { class: "col text-end" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-success one-line-btn m-2" }, "DONE", -1))
const _hoisted_86 = { class: "card-body mb-4 pt-9 pb-0" }
const _hoisted_87 = {
  key: 0,
  class: "loader"
}
const _hoisted_88 = {
  class: "modal fade",
  tabindex: "-1",
  id: "surfaces_modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_89 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_90 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_91 = { class: "modal-header" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Choose Surfaces", -1))
const _hoisted_93 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_95 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_96 = ["onClick"]
const _hoisted_97 = {
  key: 0,
  class: "m-2 my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.copied_clipboard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/notes/templates",
            class: "text-right position-absolute close-link"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(!_ctx.showFullScreen ? `col-8 d-flex flex-column` : ''),
              style: {"min-height":"580px"}
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.noteTemplateSelected), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("i", {
                    class: _normalizeClass(`fa-solid fa-circle-chevron-left mx-2 fs-40-px cursor-pointer`),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selecterdecrementOrIncrement(-1)))
                  }),
                  (_ctx.selectorIndex < _ctx.fieldList.length - 1)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(`fa-solid fa-circle-chevron-right fs-40-px cursor-pointer ${_ctx.selectorIndex < _ctx.fieldList.length - 1 ? 'color-blue' : ''}`),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selecterdecrementOrIncrement(1)))
                      }, null, 2))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "custom-button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.preview()))
                      }, "SUBMIT"))
                ]),
                _hoisted_14
              ]),
              (_ctx.noteIsSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldList, (item, index) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: item.name
                      }, [
                        (item.type == 'Text')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("h4", _hoisted_17, [
                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                _createElementVNode("input", {
                                  class: "custom-extra-input my-5 mx-2",
                                  id: item.name,
                                  onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.inputClicked && _ctx.inputClicked(...args))),
                                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.instantPreview && _ctx.instantPreview(...args)))
                                }, null, 40, _hoisted_18),
                                _hoisted_19
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 'Drop down')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("h4", _hoisted_21, [
                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                _createElementVNode("input", {
                                  class: "custom-extra-input my-5 mx-2",
                                  onChange: ($event: any) => (_ctx.setFieldExtraValue($event, item.name)),
                                  id: `extra_${item.name.replaceAll(' ', '_')}`
                                }, null, 40, _hoisted_22),
                                _hoisted_23
                              ]),
                              _createElementVNode("select", {
                                class: "form-control dropdown-element",
                                id: item.name,
                                size: "8",
                                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.instantPreview && _ctx.instantPreview(...args)))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "column-dropdown py-3",
                                    key: option,
                                    selected: option.isDefault,
                                    value: option.value
                                  }, _toDisplayString(option.value), 9, _hoisted_25))
                                }), 128))
                              ], 40, _hoisted_24)
                            ]))
                          : _createCommentVNode("", true),
                        ((item.type == 'Toothselect' || item.type == 'Tooth surface select'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("h4", _hoisted_29, [
                                    _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                    _createElementVNode("input", {
                                      class: "custom-extra-input my-5 mx-2",
                                      onChange: ($event: any) => (_ctx.setFieldExtraValue($event, item.name)),
                                      id: `extra_${item.name.replaceAll(' ', '_')}`
                                    }, null, 40, _hoisted_30),
                                    _hoisted_31
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("ul", _hoisted_33, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teeth.first, (firstQuad, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "m-2"
                                      }, [
                                        _createElementVNode("button", {
                                          class: _normalizeClass(`btn-fixed btn btn-light btn-custom ${_ctx.type5Object[item.name].selectedTeeth && _ctx.type5Object[item.name].selectedTeeth.find((x) => x === firstQuad) ? 'btn-primary' : 'btn-secondary'}`),
                                          onClick: ($event: any) => (_ctx.selectTooth($event, firstQuad, item.type, item.name))
                                        }, _toDisplayString(firstQuad), 11, _hoisted_34)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("ul", _hoisted_36, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teeth.second, (secondQuad, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "m-2"
                                      }, [
                                        _createElementVNode("button", {
                                          class: _normalizeClass(`btn-fixed btn btn-light btn-custom ${_ctx.type5Object[item.name].selectedTeeth && _ctx.type5Object[item.name].selectedTeeth.find((x) => x === secondQuad) ? 'btn-primary' : 'btn-secondary'}`),
                                          onClick: ($event: any) => (_ctx.selectTooth($event, secondQuad, item.type, item.name))
                                        }, _toDisplayString(secondQuad), 11, _hoisted_37)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("ul", _hoisted_39, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teeth.third, (thirdQuad, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "m-2"
                                      }, [
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.selectTooth($event, thirdQuad, item.type, item.name)),
                                          class: _normalizeClass(`btn-fixed btn btn-light  btn-custom ${_ctx.type5Object[item.name].selectedTeeth && _ctx.type5Object[item.name].selectedTeeth.find((x) => x === thirdQuad) ? 'btn-primary' : 'btn-secondary'}`)
                                        }, _toDisplayString(thirdQuad), 11, _hoisted_40)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("ul", _hoisted_42, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teeth.fourth, (fourthQuad, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "m-2"
                                      }, [
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.selectTooth($event, fourthQuad, item.type, item.name)),
                                          class: _normalizeClass(`btn-fixed btn btn-light btn-custom ${_ctx.type5Object[item.name].selectedTeeth && _ctx.type5Object[item.name].selectedTeeth.find((x) => x === fourthQuad) ? 'btn-primary' : 'btn-secondary'}`)
                                        }, _toDisplayString(fourthQuad), 11, _hoisted_43)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("ul", _hoisted_45, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teeth.fifth, (fifthQuad, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "m-2"
                                      }, [
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.selectTooth($event, fifthQuad, item.type, item.name)),
                                          class: _normalizeClass(`btn-fixed btn btn-light btn-custom ${typeof fifthQuad == 'string' ? 'btn-text-tooth' : ''} ${_ctx.type5Object[item.name].selectedTeeth && _ctx.type5Object[item.name].selectedTeeth.find((x) => x === fifthQuad) ? 'btn-primary' : 'btn-secondary'}`)
                                        }, _toDisplayString(fifthQuad), 11, _hoisted_46)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("ul", _hoisted_48, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teeth.sixth, (sixthQuad, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "m-2"
                                      }, [
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.selectTooth($event, sixthQuad, item.type, item.name)),
                                          class: _normalizeClass(`btn-fixed btn btn-light btn-custom ${typeof sixthQuad == 'string' ? 'btn-text-tooth' : ''} ${_ctx.type5Object[item.name].selectedTeeth && _ctx.type5Object[item.name].selectedTeeth.find((x) => x === sixthQuad) ? 'btn-primary' : 'btn-secondary'}`)
                                        }, _toDisplayString(sixthQuad), 11, _hoisted_49)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("ul", _hoisted_51, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teeth.seventh, (seventhQuad, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "m-2"
                                      }, [
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.selectTooth($event, seventhQuad, item.type, item.name)),
                                          class: _normalizeClass(`btn-fixed btn btn-light btn-custom ${_ctx.type5Object[item.name].selectedTeeth && _ctx.type5Object[item.name].selectedTeeth.find((x) => x === seventhQuad) ? 'btn-primary' : 'btn-secondary'}`)
                                        }, _toDisplayString(seventhQuad), 11, _hoisted_52)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("ul", _hoisted_54, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teeth.eighth, (eighthQuad, index) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: "m-2"
                                      }, [
                                        _createElementVNode("button", {
                                          onClick: ($event: any) => (_ctx.selectTooth($event, eighthQuad, item.type, item.name)),
                                          class: _normalizeClass(`btn-fixed btn btn-light btn-custom ${_ctx.type5Object[item.name].selectedTeeth && _ctx.type5Object[item.name].selectedTeeth.find((x) => x === eighthQuad) ? 'btn-primary' : 'btn-secondary'}`)
                                        }, _toDisplayString(eighthQuad), 11, _hoisted_55)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _hoisted_56
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 'Multiselect')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              _createElementVNode("h4", _hoisted_58, [
                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                _createElementVNode("input", {
                                  class: "custom-extra-input my-5 mx-2",
                                  onChange: ($event: any) => (_ctx.setFieldExtraValue($event, item.name)),
                                  id: `extra_${item.name.replaceAll(' ', '_')}`
                                }, null, 40, _hoisted_59),
                                _hoisted_60
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (option) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    class: "list-group-item pb-1 my-1",
                                    key: option
                                  }, [
                                    _createElementVNode("input", {
                                      class: "form-check-input me-1 checkbox-round",
                                      type: "checkbox",
                                      checked: option.isDefault,
                                      id: option.tokenPossibleValueId,
                                      value: option.value,
                                      "data-group": item.name,
                                      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.instantPreview && _ctx.instantPreview(...args))),
                                      onClick: ($event: any) => (_ctx.multiselectClick(option, item, $event))
                                    }, null, 40, _hoisted_62),
                                    _createTextVNode(" " + _toDisplayString(option.value), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 'Multiselect and count')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                              _createElementVNode("h4", _hoisted_64, [
                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                _createElementVNode("input", {
                                  class: "custom-extra-input my-5 mx-2",
                                  onChange: ($event: any) => (_ctx.setFieldExtraValue($event, item.name)),
                                  id: `extra_${item.name.replaceAll(' ', '_')}`
                                }, null, 40, _hoisted_65),
                                _hoisted_66
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (option) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    class: "list-group-item pb-1 my-1",
                                    key: option
                                  }, [
                                    _createElementVNode("input", {
                                      class: "form-check-input me-1 checkbox-round",
                                      type: "checkbox",
                                      checked: option.isDefault,
                                      id: `_${option.tokenPossibleValueId}`,
                                      value: option.value,
                                      onChange: ($event: any) => (_ctx.multiselectAndCountClick(option, item, $event)),
                                      "data-group": item.name
                                    }, null, 40, _hoisted_68),
                                    (!option.isNone)
                                      ? (_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          type: "number",
                                          class: "custom-extra-input mx-1",
                                          min: "0",
                                          style: {"width":"50px"},
                                          id: `counter_${option.tokenPossibleValueId}`,
                                          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.instantPreview && _ctx.instantPreview(...args)))
                                        }, null, 40, _hoisted_69))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(option.value), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])), [
                        [_vShow, index == _ctx.selectorIndex]
                      ])
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("i", {
                    class: _normalizeClass(`fa-solid fa-circle-chevron-left mx-2 fs-40-px cursor-pointer`),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selecterdecrementOrIncrement(-1)))
                  }),
                  (_ctx.selectorIndex < _ctx.fieldList.length - 1)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(`fa-solid fa-circle-chevron-right fs-40-px cursor-pointer ${_ctx.selectorIndex < _ctx.fieldList.length - 1 ? 'color-blue' : ''}`),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selecterdecrementOrIncrement(1)))
                      }, null, 2))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "custom-button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.preview()))
                      }, "SUBMIT"))
                ]),
                _hoisted_73,
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldList, (x, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        id: `progress${i}`,
                        class: _normalizeClass(`progress-bar mx-1 mt-5 col ${_ctx.selectorIndex >= i ? 'progress-complete' : ''}`)
                      }, [
                        _withDirectives(_createElementVNode("small", {
                          class: _normalizeClass(`steps ${_ctx.selectorIndex == i ? 'active' : ''} text-center`)
                        }, "Step " + _toDisplayString(i + 1), 3), [
                          [_vShow, _ctx.selectorIndex == i || i == _ctx.fieldList.length - 1]
                        ])
                      ], 10, _hoisted_76))
                    }), 128))
                  ])
                ]),
                _hoisted_77
              ])
            ], 2), [
              [_vShow, !_ctx.showFullScreen]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(`${_ctx.showFullScreen ? 'col-12' : 'col-4'}`)
            }, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("h6", _hoisted_79, [
                  (_ctx.showFullScreen)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "fa-solid fa-share fs-24-px mx-5 cursor-pointer",
                        style: {"color":"#dbdbdb","transform":"rotateY(180deg)"},
                        onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.showFullScreen = !_ctx.showFullScreen; _ctx.revertStep();})
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_80
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("h5", _hoisted_82, _toDisplayString(_ctx.noteTemplateSelected), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control mb-1",
                    id: "note-text",
                    style: {"min-height":"577px"},
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (( _ctx.noteTemplate ) = $event))
                  }, null, 512), [
                    [_vModelText,  _ctx.noteTemplate ],
                    [_vShow,  _ctx.showFullScreen ]
                  ]),
                  _withDirectives(_createElementVNode("div", {
                    class: "highlights",
                    ref: "textareafake"
                  }, _toDisplayString(_ctx.returnHighlightedNote()), 513), [
                    [_vShow,  !_ctx.showFullScreen ]
                  ])
                ]),
                ( _ctx.showFullScreen )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createVNode(_component_router_link, {
                          to: "/notes/templates",
                          class: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_85
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ], 512), [
          [_vShow, !_ctx.loading]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_86, [
          ( _ctx.loading )
            ? (_openBlock(), _createElementBlock("div", _hoisted_87))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow,  _ctx.loading ]
        ])
      ]),
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          ( _ctx.fieldList && _ctx.fieldList[_ctx.selectorIndex] && (_ctx.fieldList[_ctx.selectorIndex].type == 'Tooth surface select' || _ctx.fieldList[_ctx.selectorIndex].type == 'Toothselect') )
            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _hoisted_92,
                  _createElementVNode("div", _hoisted_93, [
                    _hoisted_94,
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
                  ])
                ]),
                ( _ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth[_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth.length - 1] )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkSurfacesForTeethNumber(_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth[_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth.length - 1]), (surface, i) => {
                        return (_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass( `btn ${_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].surfaces[_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth.length - 1].find(x => x == surface) ? 'btn-primary' : 'btn-secondary'} mx-1` ),
                          key:  i ,
                          onClick: ($event: any) => ( _ctx.addSurfaceForTooth(_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth[_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth.length - 1], surface, _ctx.fieldList[_ctx.selectorIndex].name) )
                        }, _toDisplayString(surface), 11, _hoisted_96))
                      }), 128)),
                      _createElementVNode("button", {
                        class: "btn btn-primary color-white",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ( _ctx.closeSurfacesModal  &&  _ctx.closeSurfacesModal (...args)))
                      }, "✓"),
                      (_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].surfaces[_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth.length-1])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth[_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth.length
							- 1]) + ": " + _toDisplayString(_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].surfaces[_ctx.type5Object[_ctx.fieldList[_ctx.selectorIndex].name].selectedTeeth.length
							- 1].join("")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}